import { Globe2, MapPin } from "lucide-react";
import { Container } from "@/components/ui/container";
import { SectionHeading } from "@/components/ui/section-heading";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { launchJurisdictions, plannedJurisdictions } from "@/lib/content";

export function JurisdictionCoverage() {
  return (
    <section aria-labelledby="jurisdiction-heading" className="py-16 sm:py-24">
      <Container>
        <SectionHeading
          titleId="jurisdiction-heading"
          eyebrow="Jurisdiction-aware by design"
          title="Privacy requirements that adapt to your business."
          description="One workspace can activate more than one privacy framework from the same factual onboarding answers. The rules are versioned and the reason for each activation stays visible."
        />

        <div className="mx-auto mt-12 grid max-w-5xl gap-6 lg:grid-cols-[1.35fr_0.65fr]">
          <div className="grid gap-5 sm:grid-cols-2">
            {launchJurisdictions.map((pack, index) => {
              const Icon = index === 0 ? MapPin : Globe2;
              return (
                <Card key={pack.name} className="h-full min-w-0 border-primary/20">
                  <CardHeader>
                    <div className="mb-3 flex items-center justify-between gap-3">
                      <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent text-accent-foreground">
                        <Icon className="h-5 w-5" aria-hidden="true" />
                      </span>
                      <Badge variant="brand">{pack.status}</Badge>
                    </div>
                    <CardTitle>{pack.name}</CardTitle>
                  </CardHeader>
                  <CardContent className="pt-0">
                    <p className="text-sm leading-relaxed text-muted-foreground">{pack.body}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <div className="rounded-2xl border border-border bg-secondary/30 p-6 sm:p-8">
            <Badge variant="outline">Planned expansion</Badge>
            <h3 className="mt-4 text-xl font-semibold text-foreground">Built to add overlays without rebuilding the core.</h3>
            <ul className="mt-5 space-y-5">
              {plannedJurisdictions.map((item) => (
                <li key={item.name}>
                  <p className="font-semibold text-foreground">{item.name}</p>
                  <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{item.body}</p>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-xs leading-relaxed text-muted-foreground">
              Canada and US/state packs are roadmap items and are not presented as supported launch packs.
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
}
